export const LIST_LOYALTY_TIERS_REQUEST = 'LIST_LOYALTY_TIERS_REQUEST';
export const RESET_LOYALTY_TIER_QUERY = 'RESET_LOYALTY_TIER_QUERY';
export const LOYALTY_TIER_REQUESTING = 'LOYALTY_TIER_REQUESTING';
export const LIST_LOYALTY_TIERS_SUCCESS = 'LIST_LOYALTY_TIERS_SUCCESS';
export const RESET_LOYALTY_TIER_ISFETCHING = 'RESET_LOYALTY_TIER_ISFETCHING';
